import { useQuery } from "@tanstack/react-query";
import { fetchCurrentSubscription } from "@remotes/fetchCurrentSubscription";

export function useCurrentSubscription() {
  return useQuery({
    queryKey: ["useCurrentSubscription"],
    queryFn: () => fetchCurrentSubscription(),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    staleTime: 0, // Consider data stale immediately
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
}
